<template>
  <div>
    <collapse
      :collapse="[
        'Services'
      ]"
      icon="keyboard_arrow_down"
      color-collapse="success"
      :defaultActive="defaultActiveCollapseIndex"
      id="Services"
    >
      <template slot="md-collapse-pane-1">
        <div class="_taskView">

          <md-table v-if="items && items.length" v-model="items[0]"  @md-selected="onSelect" class="paginated-table table-striped table-hover _taskView__table __listControl">

            <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="multiple" md-auto-select>
              <md-table-cell md-label="Name">
                <span>{{ item.name }}</span>
              </md-table-cell>

              <md-table-cell md-label="Status">
                <span>{{ item.status }}</span>
              </md-table-cell>

              <md-table-cell md-label="Created" class="cell-align">
                <span>{{ item.createdAt }}</span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        
        </div>
      </template>
    </collapse>
  </div>
</template>

<script>
import { Collapse } from "@/components";
  export default {
    name: "crud-listcontrol",
    components: {
      Collapse
    },
    props: {
      items: {
        type: [Array, Object],
      }
    },
    data() {
      return {
        selected: [],
        selectedIds: [],
        defaultActiveCollapseIndex: 1,
      }
    },
    methods: {
      onSelect: function (items) {
        this.selected = items;
        this.selectedIds = [];

        this.selected.forEach(el => {
          let selItem = {};
          selItem['id'] = el.id;
          selItem['name'] = el.name;
          this.selectedIds.push(selItem);
        });

        //pass selected serviceIds to parent component
        this.$emit('selectedServices', this.selectedIds);
      },
    },
    watch: {
      "items": {
        deep: true,
        immediate: true,
        handler: function() {
          const id = this.$route.params.id;
          let index = -1;
          this.items.forEach(item => {
            const _index = item.findIndex(_child => {
              return _child.id === id;
            });
            if(_index !== -1) {
              index = _index;
            }
          })
          //emit event to off loader
          this.$emit('isShowLoader', false);

          if (index === -1) {
            return;
          }
          //pre-check the serviceid being viewed
          window.setTimeout(() => {
            const selector = `tbody tr:nth-child(${index+1}) input[type='checkbox']`;
            const checkBoxElement = this.$el.querySelector(selector);
            if (checkBoxElement) {
              checkBoxElement.click();
            }
          }, 1000);
          
        }
      }
    }
  };
</script>

<style scoped>
.md-content.md-table.paginated-table.table-striped.table-hover._taskView__table.md-theme-default {
    max-height: 345px;
}
._taskView__table .md-table-content table, ._taskView__table .md-table-content th, ._taskView__table .md-table-content td {
    font-size: 0.72rem !important;
    border: 1px solid #ddd !important;
}
h3.md-title {
    font-size: 0.75em !important;
    color: #13294d;
    font-weight: 500;
}
.paginated-table .md-table-cell.cell-align .md-table-cell-container, .paginated-table.last_cell .md-table-head:last-child {
    text-align: left !important;
    display: table-cell;
}
div#Services {
    width: 598px;
}
</style>

<style>
._taskView__table .md-table-content th:nth-child(1) {
    width: 10% !important;
}
.paginated-table.__listControl .md-table-head-label {
    padding-right: 0px;
}
._taskView .paginated-table .md-table-cell:last-child .md-table-cell-container {
    justify-content: flex-start !important;
}
._taskView__table .md-table-content th {
    font-size: 12px !important;
    font-weight: 600;
}
._taskView__table .md-table-content th, ._taskView__table .md-table-content td {
    padding: 0 !important;
}
._taskView__table .md-table-cell-selection+td .md-table-cell-container {
    padding-left: 5px;
}
</style>
